import { Link } from "react-router-dom";
import { Scale, BadgeCheck, Zap, ShieldCheck, Headphones, Phone, Mail, MapPin } from "lucide-react";
import { IMAGES } from "../lib/api";
import { useSite } from "../context/SiteContext";
import { Logo } from "./ui";

const BENEFIT_ICONS = [Scale, BadgeCheck, Zap, ShieldCheck, Headphones];

export default function Footer() {
  const { site } = useSite();
  const f = site?.footer;
  if (!f) return null;
  const contacts = [[Phone, f.phone], [Mail, f.email], [MapPin, f.address]].filter(([, v]) => v);
  return (
    <footer className="mt-10" data-testid="site-footer">
      <div className="relative h-56 overflow-hidden sm:h-64">
        <img src={f.image || IMAGES.panorama} alt="Panorama de São Tomé e Príncipe" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-bo-green/90 via-bo-green/50 to-transparent" />
        <div className="relative mx-auto flex h-full max-w-[1600px] items-center px-5">
          <p className="max-w-md text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-testid="footer-tagline">{f.tagline_1}<br /><span className="text-bo-yellow">{f.tagline_2}</span></p>
        </div>
      </div>
      {f.benefits.length > 0 && <div className="bg-bo-green">
        <div className="mx-auto grid max-w-[1600px] grid-cols-2 gap-4 px-5 py-6 sm:grid-cols-3 lg:grid-cols-5">
          {f.benefits.map((label, i) => { const Icon = BENEFIT_ICONS[i % BENEFIT_ICONS.length]; return (
            <div key={label} className="flex items-center gap-3 text-white">
              <span className="grid h-10 w-10 place-items-center rounded-full bg-bo-yellow text-bo-green"><Icon className="h-5 w-5" /></span>
              <span className="text-sm font-semibold">{label}</span>
            </div>); })}
        </div>
      </div>}
      <div className="bg-bo-deep">
        <div className="mx-auto flex max-w-[1600px] flex-wrap items-center justify-between gap-4 px-5 py-5 text-xs text-white/70">
          <Logo light />
          <div className="flex flex-wrap items-center gap-4" data-testid="footer-links">
            {contacts.map(([Icon, v]) => <span key={v} className="flex items-center gap-1.5"><Icon className="h-3.5 w-3.5" />{v}</span>)}
            {site.footer_pages.map((p) => <Link key={p.slug} to={`/p/${p.slug}`} className="font-semibold text-white hover:text-bo-yellow" data-testid={`footer-page-${p.slug}`}>{p.title}</Link>)}
          </div>
          <p>{f.legal}</p>
          <p className="flex items-center gap-3">© {new Date().getFullYear()} {f.copyright}<Link to="/admin" className="text-[11px] text-white/40 hover:text-white/70" data-testid="footer-admin-link">Admin</Link><Link to="/painel-loja" className="text-[11px] text-white/40 hover:text-white/70" data-testid="footer-stores-link">Lojas</Link></p>
        </div>
      </div>
    </footer>
  );
}
